import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 400px;
    gap: 16px;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: ${(props: any) => props.theme.colors.interfaceGray300} ${(props: any) => props.theme.colors.background};
    &::-webkit-scrollbar {
      width: 12px;
      background: ${(props: any) => props.theme.colors.interfaceText200};
      border-radius: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${(props: any) => props.theme.colors.primaryBlue100};
      border-radius: 12px;
    }

    .line-info {
        display: flex;
        align-items: center;
        gap: 32px;

        &:first-child {
            .bullet {
                &::after {
                    content: '';
                    border-left: none;
                    height: 0;
                    /* position: absolute; */
                    top: 0;
                    left: 0;
                }
            }
        }

        .date {
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            color: ${({ theme }) => theme.colors.interfaceText400};
        }

        .bullet {
            display: flex;
            align-items: center;
            position: relative;

            svg {
                circle {
                    fill: ${({ theme }) => theme.colors.interfaceText400};
                }
            }

            &::after {
                content: '';
                border-left: 2px solid ${({ theme }) => theme.colors.interfaceText400};
                height: 50px;
                position: absolute;
                top: 1px;
                left: 3px;                
                margin-top: -50px;
            }

            

            &.start {
                svg {
                    circle {
                        fill: ${({ theme }) => theme.colors.interfaceSuccess400};
                    }
                }
            }

            &.end {
                svg {
                    circle {
                        fill: ${({ theme }) => theme.colors.interfaceDanger400};
                    }
                }

                &::after {
                    content: '';
                    border-left: none;
                    height: 50px;
                    position: absolute;
                    top: 7px;
                    left: 3px;
                }
            }
        }

        .bullet-start {
            display: flex;
            align-items: center;
            svg {
                circle {
                    fill: ${({ theme }) => theme.colors.interfaceSuccess400};
                }
            }
        }

        .event {
            display: flex;
            align-items: center;
            height: 40px;
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.colors.interfaceText400};
        }
    }
`